import React, {Component} from 'react';
import ticketpng from '../assets/img/ticket.png'

class Ticket extends Component {
    render(){
        return(
            <div style={{
                width: '560px',
                height: '666px',
                backgroundImage:'url('+ticketpng+')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}>
                <div style={{
                        font:'12px Arial, Sans-serif',
                        width: '560px',
                        height: 'auto',
                        top: '18%',
                        textAlign: 'center',
                        position: 'absolute',
                }}>
                 <h2>Ecoparking</h2>
                 <h6>15.081.667/0001-33</h6>
                 <hr style={{width: '47%'}}/>
                 <h5>Recibo de Ticket - {this.props.receipt}</h5>
                 <hr style={{width: '47%'}}/>
                 <h6><b>Valor: </b><br/>{this.props.value}</h6><br/>
                 <h6><b>Data: </b><br/> {this.props.date}</h6><br/>
                 <h6><b>Placa: </b><br/>{this.props.plate}</h6><br/>
                 <h6><b>Tempo: </b><br/>{this.props.time}</h6>
                 <hr style={{width: '47%'}}/>
                 <p>Payparking Mobilidade Urbana 
                     <br/> Av. Fernando Ferrari, 1080,
                     <br/> Torre Norte - Sala 503 
                     <br/> Vitoria - ES
                     <br /> www.payparking.com </p>
                </div>
            </div>
        );
    }
}
export default Ticket;


// WEBPACK FOOTER //
// ./src/components/Ticket.js